// extracted by mini-css-extract-plugin
export default {"container":"RecommendationQuote-module--container--fde42","author":"RecommendationQuote-module--author--9dc6d","image":"RecommendationQuote-module--image--ee07c"};